"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DrawableWriter = void 0;
const core_api_1 = require("@ikegps/core-api");
const __1 = require("../..");
const line_drawable_1 = require("../drawable/line.drawable");
const marker_drawable_1 = require("../drawable/marker.drawable");
const marker_offset_drawable_1 = require("../drawable/marker.offset.drawable");
const mask_drawable_1 = require("../drawable/mask.drawable");
function writeLink(collection, fieldId) {
    const collectionField = collection.getFieldDeep(fieldId);
    if (collectionField == null) {
        return null;
    }
    const formField = collectionField.schema;
    return {
        name: formField.id,
        formID: collectionField.parent.instanceId,
        text: collectionField.annotationLabel
    };
}
function writeLabelDrawable(label) {
    return {
        id: label.id,
        tag: core_api_1.DrawableTag.LABEL,
        x: label.x,
        y: label.y,
        text: label.text.length === 1 ? label.text[0] : undefined
    };
}
function writeMarkerDrawable(collection, drawable) {
    const links = drawable.label.links.map(field => writeLink(collection, field.id)).filter(link => !!link);
    if (drawable.type === core_api_1.MarkerType.BASE) {
        throw new Error(`Base Marker Drawable was passed to writeMarkerDrawable but should be passed to writeBaseMarkerDrawable instead`);
    }
    return {
        id: drawable.id,
        type: drawable.type,
        x: drawable.x,
        y: drawable.y,
        tag: core_api_1.DrawableTag.MARKER,
        label: writeLabelDrawable(drawable.label),
        link: links.length > 0 ? links : undefined,
        pair: drawable.pair ? drawable.pair : undefined,
        insight: drawable.insight ? drawable.insight : undefined
    };
}
function writeBaseMarkerDrawable(collection, drawable) {
    var _a;
    const links = drawable.label.links.map(field => writeLink(collection, field.id)).filter(link => !!link);
    if (drawable.type !== core_api_1.MarkerType.BASE) {
        throw new Error(`Non-Base Marker Drawable was passed to writeBaseMarkerDrawable but should be passed to writeMarkerDrawable instead`);
    }
    return {
        id: drawable.id,
        type: drawable.type,
        x: drawable.x,
        y: drawable.y,
        tag: core_api_1.DrawableTag.MARKER,
        label: writeLabelDrawable(drawable.label),
        link: links.length > 0 ? links : undefined,
        pair: drawable.pair ? drawable.pair : undefined,
        insight: drawable.insight ? drawable.insight : undefined,
        offset: (_a = drawable.offset) !== null && _a !== void 0 ? _a : -1
    };
}
function writeLineDrawable(collection, drawable) {
    const startPoint = drawable.start;
    const endPoint = drawable.end;
    return {
        id: drawable.id,
        tag: core_api_1.DrawableTag.LINE,
        start: { x: startPoint.x, y: startPoint.y },
        end: { x: endPoint.x, y: endPoint.y },
        label: writeLabelDrawable(drawable.label)
    };
}
function writeMaskDrawable(drawable) {
    return {
        id: drawable.id,
        tag: core_api_1.DrawableTag.MASK,
        pukeko_data: drawable.pukekoLocation
    };
}
function writeVerticalSeparationDrawable(drawable) {
    return {
        id: drawable.id,
        tag: core_api_1.DrawableTag.VERTICAL_SEPARATION,
        label: writeLabelDrawable(drawable.label),
        topMarkerId: drawable.topMarkerId,
        bottomMarkerId: drawable.bottomMarkerId,
        fieldId: drawable.fieldId
    };
}
class DrawableWriter {
    static write(collection, drawable) {
        if (marker_offset_drawable_1.CollectionModelDrawableMarkerOffset.isBaseOffset(drawable)) {
            return writeMarkerDrawable(collection, drawable);
        }
        if (marker_drawable_1.CollectionModelDrawableMarker.isMarker(drawable)) {
            if (marker_drawable_1.CollectionModelDrawableMarker.isBase(drawable)) {
                return writeBaseMarkerDrawable(collection, drawable);
            }
            return writeMarkerDrawable(collection, drawable);
        }
        if (line_drawable_1.CollectionModelDrawableLine.isLine(drawable)) {
            return writeLineDrawable(collection, drawable);
        }
        if (mask_drawable_1.CollectionModelDrawableMask.isMask(drawable)) {
            return writeMaskDrawable(drawable);
        }
        if (drawable instanceof __1.CollectionModelDrawableVerticalSeparation) {
            return writeVerticalSeparationDrawable(drawable);
        }
        return null;
    }
}
exports.DrawableWriter = DrawableWriter;
//# sourceMappingURL=collection.model.write.drawable.js.map